import React from "react";
import { styled } from "styled-components";

import { ClosedChatFrame } from "./ClosedChatFrame";
import { textColorForBackground } from "./textColor";
import {
  AnnouncementColors,
  AnnouncementPlacement,
  AnnouncementPosition,
} from "./types";

const Bubble = styled.button<{ $background: string; $color: string }>(
  ({ $background, $color, theme }) => ({
    padding: "11px 16px 10px 16px",
    maxWidth: 240,
    border: 0,
    textAlign: "left",
    color: $color,
    background: $background,
    borderRadius: theme.radii[2],
    boxShadow: theme.shadows.surfaceZ1Light,
    fontSize: 14,
    cursor: "pointer",
  }),
);

export interface ChatBubbleProps extends AnnouncementColors {
  message: string;
  placement: AnnouncementPlacement;
  position?: AnnouncementPosition;
  onClick?: () => void;
  onDismiss?: () => void;
}

export const ChatBubble: React.FC<ChatBubbleProps> = ({
  message,
  placement,
  position = "right",
  primaryColor,
  onClick,
  onDismiss,
}) => {
  return (
    <ClosedChatFrame
      placement={placement}
      position={position}
      onDismiss={onDismiss}
      label="Chat bubble"
    >
      <Bubble
        type="button"
        $background={primaryColor}
        $color={textColorForBackground(primaryColor)}
        onClick={onClick}
      >
        {message}
      </Bubble>
    </ClosedChatFrame>
  );
};
